.storeDetail div {
  background-image: linear-gradient(
    90deg,
    var(--bloom-colors-store-skeleton-light),
    var(--bloom-colors-store-skeleton),
    var(--bloom-colors-store-skeleton-light),
    var(--bloom-colors-store-skeleton)
    );
    transform: translate3d(0, 0, 0); /* Prevents anti-aliasing issues */
}

.storeCard {
  border-bottom: 1px solid var(--bloom-colors-store-card-border);
}
